'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileTypeIcon = require('../FileTypeIcon');

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

var _fileTypeUtil = require('../../utils/fileTypeUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageDocument = function MessageDocument(_ref) {
  var title = _ref.title,
      fileName = _ref.fileName,
      subtitle = _ref.subtitle,
      children = _ref.children,
      onClick = _ref.onClick;

  var iconProps = fileName && (0, _fileTypeUtil.iconType)(fileName);
  return _react2.default.createElement(
    'div',
    { className: 'MessageDocument', role: 'button', onClick: onClick },
    !children && _react2.default.createElement(
      'div',
      { className: 'MessageDocument__iconContainer' },
      _react2.default.createElement(_FileTypeIcon2.default, (0, _extends3.default)({ width: '48' }, iconProps)),
      title && _react2.default.createElement(
        'div',
        { className: 'MessageDocument__fileName' },
        fileName
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'MessageDocument__text' },
      _react2.default.createElement(
        'p',
        { className: 'MessageDocument__title' },
        title || fileName
      ),
      subtitle && _react2.default.createElement(
        'p',
        { className: 'MessageDocument__subtitle' },
        subtitle
      )
    )
  );
};

MessageDocument.propTypes = {
  title: _propTypes2.default.node,
  fileName: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.node,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.any
};

exports.default = MessageDocument;
//# sourceMappingURL=MessageDocument.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Conversation/MessageDocument.js
// module id = 615
// module chunks = 0